import React, { useEffect, useState } from "react"
import { useLocation } from "@reach/router"
import Datapage from "../../../components/dataDownload/datapage/Datapage.js"

const DatapageRouter = (props) => {
  const location = useLocation()
  const [datasetId, setDatasetId] = useState(null)

  useEffect(() => {
    if (location?.pathname) {
      const pathParts = location.pathname.split('/')
      const id = pathParts[pathParts.length - 1]
      setDatasetId(id)
    }
  }, [location])

  // Show loading state while extracting the dataset ID
  if (!datasetId) {
    return <div>Loading...</div>
  }

  return <Datapage id={datasetId} />
}

export default DatapageRouter
